import { useRef } from "react";
import { FormHelperText } from "@mui/material";

const FileAttachmentField = ({ label, name, formik, optional = false, disabled = false }) => {
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    if (disabled) return;
    const file = event.target.files[0];
    if (file) {
      formik.setFieldValue(name, file);
    }
  };

  const handleButtonClick = () => {
    if (!disabled) fileInputRef.current.click();
  };

  const selectedFile = formik.values[name];

  const handleFileClick = (file) => {
    if (disabled || !file) return;

    const fileUrl = file.url || URL.createObjectURL(file);
    const fileName = file.name || file.fileName || "download";

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    if (!file.url) {
      URL.revokeObjectURL(fileUrl);
    }
  };

  return (
    <div className="lg:mr-10 lg:col-span-1 col-span-2">
      {/* Matches BaseTextField's label typography so the field lines up with the rest of the form. */}
      <label
        htmlFor={name}
        className="block text-[13px] font-normal mb-1.5 text-[#686868]"
      >
        {label}
        {optional && <span className="font-light italic ml-1">- Optional</span>}
      </label>

      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        disabled={disabled}
        style={{ display: "none" }}
      />

      <div
        className={`flex items-center justify-between gap-2 w-full h-[42px] px-3 border border-[#D9D9D9] rounded-lg
          ${
            disabled
              ? "bg-[#f5f5f5] cursor-not-allowed"
              : "bg-white cursor-pointer"
          }
        `}
        onClick={handleButtonClick}
      >
        {selectedFile ? (
          <span
            title={selectedFile.name || selectedFile.fileName}
            className={`truncate text-[13px] ${
              disabled ? "text-[#9f9f9f]" : "text-primary hover:underline"
            }`}
            onClick={(e) => {
              if (disabled) return;
              e.stopPropagation();
              handleFileClick(selectedFile);
            }}
          >
            {selectedFile.name || selectedFile.fileName}
          </span>
        ) : (
          <span className="text-[13px] text-gray-400">No file selected</span>
        )}

        <i
          className={`fa-solid fa-paperclip text-base shrink-0 ${
            disabled ? "text-gray-400" : "text-primary"
          }`}
        ></i>
      </div>

      {formik.touched[name] && formik.errors[name] && (
        <FormHelperText error>{formik.errors[name]}</FormHelperText>
      )}
    </div>
  );
};

export default FileAttachmentField;
